export function navigationBuilder (navTree, permissions) {
  let mainNav = []

  for (let navItem in navTree) {
    if (_.isEmpty(navTree[navItem].submenu)) {
      // add if user has permission
      if (_.some(permissions, { key: navTree[navItem].rbac })) {
        mainNav.push(navTree[navItem])
      }
    } else {
      let submenuNav = []
      for (let submenuNavItem in navTree[navItem].submenu) {
        if (
          _.some(permissions, {
            key: navTree[navItem].submenu[submenuNavItem].rbac
          })
        ) {
          submenuNav.push(navTree[navItem].submenu[submenuNavItem])
        }
      }
      if (!_.isEmpty(submenuNav)) {
        navTree[navItem].submenu = submenuNav
        mainNav.push(navTree[navItem])
      }
    }
  }

  return mainNav
}



// WEBPACK FOOTER //
// ./src/utilities/user/permission/ability.js